import { ContentFulComponents, HeroImageComponentType } from "@swo/storefront";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { pipe } from "fp-ts/lib/function";
import { array as A, option as O } from "fp-ts";

function isHeroImageComponent(c: ContentFulComponents): c is HeroImageComponentType & ContentfulComponentCMSHook {
  return c.__typename === "ComponentHeroImage";
}

export function getFallbackImageFromComponents(components: Array<ContentFulComponents | string>): string | undefined {
  return pipe(
    components.flatMap(c => (typeof c === "string" ? [] : [c])),
    A.filter(isHeroImageComponent),
    A.head,
    O.chain(c => {
      return pipe(
        c.desktopVisualAsset.__typename === "UtilityImageWithFocalPoint" ? O.some(c.desktopVisualAsset) : O.none,
        O.alt(() =>
          c.mobileVisualAsset?.__typename === "UtilityImageWithFocalPoint"
            ? O.fromNullable(c.mobileVisualAsset)
            : O.none,
        ),
      );
    }),
    O.map(c => c.image.url),
    O.toUndefined,
  );
}
